<template>
  <VueDatePicker
    v-if="isVisible"
    v-model="selectedDate"
    inline
    auto-apply
    :min-date="new Date()"
    prevent-min-max-navigation
    :enable-time-picker="false"
    month-name-format="long"
    locale="fr"
    class="datepicker"
    :year-range="yearRange"
    :hide-offset-dates="true"
    :max-date="maxDate"
  >
    <template #arrow-left>
      <img
        class="slot-icon"
        src="../../assets/icons/prev.svg"
      />
    </template>
    <template #arrow-right>
      <img
        class="slot-icon"
        src="../../assets/icons/next.svg"
      />
    </template>
  </VueDatePicker>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const emit = defineEmits(["select"]);
/* eslint-disable no-unused-vars */
const props = defineProps({
  isVisible: Boolean,
});
/* eslint-enable no-unused-vars */

const selectedDate = ref(new Date());

watch(
  () => selectedDate.value,
  () => {
    emit("select", selectedDate.value);
  }
);

const yearRange = computed(() => {
  let currentDate = new Date(Date.now());
  let currentYear = currentDate.getFullYear();
  return [currentYear, currentYear + 1];
});

const maxDate = computed(() => {
  let currentDate = new Date(Date.now());
  let currentTimePlusOneYear = currentDate.getTime() + 31557600000;
  return new Date(currentTimePlusOneYear);
});
</script>

<style>
.booking-datepicker > div + div {
  width: 100%;
}
.booking-datepicker .dp__menu {
  border-radius: 0;
  border-color: rgba(0 0 0 / 10%);
}
.booking-datepicker .dp__calendar_header_separator {
  display: none;
}
.booking-datepicker .dp__calendar_header {
  font-size: 0.75rem;
  font-weight: normal;
  color: rgba(60 60 67 / 60%);
  text-transform: capitalize;
}
.booking-datepicker .dp__calendar_item {
  display: flex;
  justify-content: center;
}
.booking-datepicker .dp__date_hover:hover {
  border-radius: 5rem;
}
.booking-datepicker .dp__active_date {
  background-color: rgb(var(--brand-primary) / 1);
  border-radius: 5rem;
  border: none;
}
.booking-datepicker .dp__month_year_wrap {
  font-weight: bold;
  width: auto;
}
.booking-datepicker .dp__month_year_select {
  width: auto;
}
.booking-datepicker .dp__inner_nav_disabled {
  background: none;
  opacity: 0.3;
}
.booking-datepicker .dp--header-wrap {
  align-items: center;
}
.booking-datepicker .dp__today {
  border-radius: 5rem;
  border-color: rgb(var(--brand-primary) / 1);
}

@media screen and (min-width: 1000px) {
  .booking-datepicker {
    left: 1rem !important;
    right: 1rem;
    top: 3rem !important;
  }
  .booking-datepicker > div + div {
    width: calc(100% - 2rem);
  }
  .booking-datepicker .dp__month_year_select {
    width: 50%;
  }
  .booking-datepicker .dp__month_year_wrap {
    align-items: center;
    width: 100%;
  }
}
</style>
